<template>
  <div class="user-login-box">
    <h1 class="" :title="$t('top_title')"></h1>
    <h2 class="about">{{$t('sub_title')}}</h2>
    <div class="login">
      <form method="post" @submit.prevent="login" autocomplete="on">
        <label class="label">{{$t('login_id')}}</label><span class="help is-danger" v-html="e_msg_u_id"></span>
        <p class="control"><input type="text" name="user_id" autocomplete="on" :placeholder="$t('login_id')" class="input" v-model="user_id"></p>
        <label class="label">{{$t('pass')}}</label><span class="help is-danger" v-html="e_msg_u_pass"></span>
        <input type="password" name="user_pass" autocomplete="on" :placeholder="$t('pass')" class="input" v-model="user_pass">
        <input class="button" type="submit" :value="$t('login')">
      </form>
    </div>

    <div class="footer">
      Produced by LC&Pe Inc.
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserLogin',
  // ===========================================================================
  // language
  // ===========================================================================
  language: {
    'ja': {
      'top_title': 'Stay Assist',
      'sub_title': '宿泊者用サインイン',
      'login_id': 'サインインID',
      'pass': 'パスワード',
      'login': 'サインイン',
      'reloaded': 'ブラウザがリロードされたため、サインアウトしました。\n再度サインインしてください。',
      'logouted': 'サインアウトしました。',
      'err_login_id': 'サインインIDを入力してください。',
      'err_pass': 'パスワードを入力してください。',
    },
    'en': {
      'top_title': 'Stay Assist',
      'sub_title': 'Guest Sign in',
      'login_id': 'Sign in ID',
      'pass': 'Password',
      'login': 'Sign in',
      'reloaded': 'I signed out because the browser was reloaded.\nPlease signin again.',
      'logouted': 'Sign out.',
      'err_login_id': 'Please enter signin ID',
      'err_pass': 'Please enter Password',
    }
  },
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      e_msg_u_id: '',
      e_msg_u_pass: '',
      user_id: '',
      user_pass: '',
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.$store.commit('loginInfo/set_lang', this.$route.query.lang);
    this.$store.commit('loginInfo/set_login_type', 'user');
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    if (this.$route.query.type === 'reload') {
      this.$alert('alert', '');
    } else if (this.$route.query.type === 'logout') {
      this.$alert('alert', this.$t('logouted'));
    }
    this.$t('login_id');

    document.getElementsByTagName('title')[0].innerHTML = 'Stay Assist (for guest)';

    if (this.$route.query.id) {
      this.user_id = this.$route.query.id;
    }
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    login () {
      let eFlg = false;
      if (!this.user_id) {
        this.e_msg_u_id = this.$t('err_login_id');
        eFlg = true;
      } else {
        this.e_msg_u_id = '';
      }
      if (!this.user_pass) {
        this.e_msg_u_pass = this.$t('err_pass');
        eFlg = true;
      } else {
        this.e_msg_u_pass = '';
      }
      if (eFlg === false) {
        let ld = new this.$loader(this);
        ld._data_set({user_id: this.user_id, user_pass: this.user_pass});
        ld._post_cb_f = this.login_cb;
        ld._load_start('login_user.php');
        // this.$store.commit('loginInfo/set_data', {'token': 'aa'});
        // this.$router.push({name: 'user_list_info', params: {}});
      }
    },
    login_cb (data) {
      if (data.res === 1) {
        this.$store.commit('loginInfo/set_data', data.data);

        this.$router.push({name: 'user_list_info', params: {}});
      } else {
        this.$alert('alert', `${this.$st('err_code')}：${data.res}`);
      }
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.user-login-box {
  text-align: center;
  padding-top: 50px;
  h1 {
    color: #24273b;
    font-size: 28px;
    letter-spacing: 2px;
    background-image: url('../../assets/logo.svg');
    height: 32px;
    width: 158px;
    margin: 0 auto;
    background-size: cover;
  }
  .about {
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    color: #24273b;
    margin: 30px auto 30px auto;
    position: relative;
    font-weight: normal;
  }
  .about2 {
    margin-bottom: 0px;
  }
  .about3 {
    color: #1d1b50;
    margin-bottom: 20px;
  }
  input {
    ime-mode: inactive;
    height: 48px;
    font-size: 18px;
  }

  .login {
    position: relative;
    width: 510px;
    margin: 10px auto;
    background: #fbfbfb;
    border: 1px solid #ceced2;
    padding: 32px 112px 40px 112px;
    border-radius: 4px;
    box-sizing: border-box;
  }

  .control {
    margin-bottom: 17px;
  }

  .label {
    text-align: left;
    // float: left;
    color: #24273b;
    padding-left: 8px;
    margin-bottom: 5px;
    display: block;
  }

  .button {
    margin-top: 25px;
    width: 150px;
    height: 40px;
    border: initial;
    border-radius: 4px;
    font-size: 16px;
  }

  .help {
    color: #ff6e5a;
    font-size: 13px;
    line-height: 1.7;
  }

  .title-header {

  }
  .footer {
    // background-image: url('../../assets/lilli.svg');
    background-repeat: no-repeat;
    background-position: right;
    -ms-background-position-x: 55px;

    width: 230px;
    margin: 50px auto 20px auto;
    text-align: left;
    height: 40px;
    line-height: 40px;
    color: #24273b;
    text-align: center;
  }

  @media (max-width: 767px) {
    padding-top: 25px;
    h1 {
      font-size: 20px;
      letter-spacing: 0px;
    }
    .login {
      width: calc(100vw - 110px);
      padding: 18px 15px 22px 15px;
      box-sizing: inherit;
    }
  }
}
</style>
